import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectCallbackReason } from '../drop-off/drop-off.selectors';
import { requestFailure } from '../error/error.actions';
import { DatanetService } from '../../services/datanet.service';
import { dropOffResponse, submitCallbackRequest } from './drop-off.actions';

@Injectable({ providedIn: 'any' })
export class DropOffEffects {
    callback$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(submitCallbackRequest),
                withLatestFrom(this.store$.select(selectCallbackReason)),
                switchMap(([request, callbackReason]) => {
                    request = { ...request };
                    request.callbackReason = request.callbackReason || callbackReason;

                    return this.callbackService$.callback(request).pipe(
                        map(() => {
                            return dropOffResponse();
                        }),
                        catchError((error) => of(requestFailure(error))),
                    );
                }),
            ),
        {
            dispatch: true,
        },
    );

    constructor(
        private readonly actions$: Actions,
        private readonly callbackService$: DatanetService,
        private readonly store$: Store,
    ) {}
}
